import { render, staticRenderFns } from "./ConfigurationForm121.vue?vue&type=template&id=52dba684&scoped=true&lang=pug&"
import script from "./ConfigurationForm121.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm121.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm121.vue?vue&type=style&index=0&id=52dba684&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dba684",
  null
  
)

export default component.exports